import { HTMLAttributes } from 'react';
import classNames from 'classnames';

import './loader.scss';

import LoaderIcon from '../common.icons/LoaderIcon';

export type TLoader = {
  color?: string;
  size?: string;
  margin?: string;
} & HTMLAttributes<HTMLDivElement>;

const Loader = ({ color, className, size = '', margin = '' }: TLoader) => {
  return (
    <div className={classNames(className, 'circle-loader-component')} style={size ? { height: size, width: size, margin: margin || '0px' } : {}}>
      <LoaderIcon color={color} />
    </div>
  );
};

export default Loader;
